import { cn as e } from "../shared/utils.js";
import { AlertCircleIcon as t, AlertTriangleIcon as n, CheckCircleIcon as r, InfoCircleIcon as i } from "@systemeio/icons";
import { forwardRef as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { cva as c } from "class-variance-authority";
//#region src/full-width-banner/full-width-banner.tsx
var l = c("w-full border-y", {
	variants: { variant: {
		warning: "bg-bg-warning-light border-border-warning-light",
		error: "bg-bg-error border-border-error-light",
		success: "bg-bg-success border-border-success-light",
		info: "bg-bg-accent-light border-border-accent"
	} },
	defaultVariants: { variant: "warning" }
}), u = {
	warning: n,
	error: t,
	success: r,
	info: i
}, d = {
	warning: "text-icon-warning",
	error: "text-icon-error",
	success: "text-icon-success",
	info: "text-icon-accent"
}, f = a(({ actions: t, children: n, className: r, contentClassName: i, role: a, variant: c = "warning", ...f }, p) => {
	let m = u[c];
	return /* @__PURE__ */ o("div", {
		ref: p,
		className: e(l({ variant: c }), r),
		"data-slot": "full-width-banner",
		"data-variant": c,
		role: a ?? (c === "error" ? "alert" : "status"),
		...f,
		children: /* @__PURE__ */ s("div", {
			className: e("text-text-primary flex w-full items-center gap-2 px-6 py-2.5 text-sm", i),
			"data-slot": "full-width-banner-content",
			children: [
				/* @__PURE__ */ o(m, { className: e("size-4 shrink-0", d[c]) }),
				/* @__PURE__ */ o("div", {
					className: "min-w-0 flex-1",
					children: n
				}),
				t && /* @__PURE__ */ o("div", {
					className: "shrink-0",
					children: t
				})
			]
		})
	});
});
f.displayName = "FullWidthBanner";
//#endregion
export { f as FullWidthBanner };
